import { EventSubscription } from '../../subscription-context';

export function pushSubscription(
  subscriptions: EventSubscription[],
  subscription: EventSubscription | null
): void {
  if (subscription) {
    subscriptions.push(subscription);
  }
}

export { subscribeAudioElement } from './audio-element.subscription';
export { subscribeConferenceEvents } from './conference-events.subscription';
export {
  cancelAgentStateInitialization,
  fetchInitialUnavailableCodes,
  initializeAgentState,
  resetAgentStateInitialization,
} from './agent-state-init';
